module.exports = __webpack_public_path__ + "static/img/page46.4430f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page46.jpg
// module id = goQs
// module chunks = 0